import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { dt } from 'src/utils/documentsI18n';
import 'src/components/documentostributarios/ModalDeleteObligations.scss';

/**
 * Cuerpo del modal de confirmación al deshacer TODOS los matchs de un registro.
 * Mismo patrón visual que DeleteReconciliationModalContent / ModalDeleteObligations.
 */
export default function UndoAllMatchesModalContent({ count = 0 }) {
  return (
    <div className="delete-obligation-modal-body">
      <div className="delete-obligation-modal-icon" aria-hidden>
        <FeatherIcon icon="trash-2" size={22} />
      </div>

      <p className="delete-obligation-modal-lead">{dt('reconcile.undoAllMatchesLead')}</p>

      {count > 0 && (
        <div className="delete-obligation-modal-summary">
          <div className="delete-obligation-modal-summary-row">
            <span className="delete-obligation-modal-summary-value">
              {dt('reconcile.undoAllMatchesCount', { count })}
            </span>
          </div>
        </div>
      )}

      <p className="delete-obligation-modal-warning">
        {dt('reconcile.undoAllMatchesWarning')}
      </p>
    </div>
  );
}
